/**
 * Liefert eine skalierte Variante über den Supabase-Image-Render-Endpunkt.
 * Ohne das lädt jede Kachel das Original-PNG in voller Auflösung.
 */
export function getAdThumbnail(
  src: string,
  width: number,
  height: number,
  quality = 72,
  resize: "cover" | "contain" = "cover",
): string {
  const rendered = src.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/",
  );
  return `${rendered}?width=${width}&height=${height}&resize=${resize}&quality=${quality}`;
}

export type PublishedStaticGridAd = Readonly<{
  src: string;
  brand: "Leguano" | "Hotty BBQ";
  product: string;
  metaAdId: string;
  status: "published";
}>;

// Curated from meta_publish_items on 2026-07-24.
// Every entry had status="published", asset_type="image", and a non-null Meta ad ID.
export const PUBLISHED_STATIC_GRID_ADS = [
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/2a0685e1-a77b-46c0-a4c0-b0cfdb42a7b8.png",
    brand: "Leguano",
    product: "aktiv lavaschwarz, schwarze Sohle",
    metaAdId: "120243539855800633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/20334417-c8ff-4c35-bc7f-4363c11f4bbf.png",
    brand: "Hotty BBQ",
    product: "Hotty Halo",
    metaAdId: "120246534723490719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/37a84138-fc0d-4d67-8a47-5abcb36b02e2.png",
    brand: "Leguano",
    product: "attrekktive black",
    metaAdId: "120246608019600633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/d9954d22-30a2-4777-a4a7-5782783a8771.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121890390719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/56967939-7f28-4672-90d3-47d08789e808.png",
    brand: "Leguano",
    product: "beat sand",
    metaAdId: "120243465475730633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/a4ba3f23-3855-430f-9cfe-f92794ac4513.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Majestic",
    metaAdId: "120248121784300719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/815f0684-4628-4d31-8755-4c0c6e175560.png",
    brand: "Leguano",
    product: "caribeo blue",
    metaAdId: "120245588363790633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/4d312195-638c-485b-9779-90aa743a563a.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Medium",
    metaAdId: "120248126267070719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/93a4daca-77ad-4db1-b4f3-b119a4913fd0.png",
    brand: "Leguano",
    product: "caribeo rose",
    metaAdId: "120243267724010633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/aa29839b-4947-4bd9-b710-a5220cd5c715.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Single",
    metaAdId: "120248126032660719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/58d43e4c-bbbe-48f8-9b57-590671a8e004.png",
    brand: "Leguano",
    product: "flair pistachio",
    metaAdId: "120247201642650633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/ad5685b2-6700-4433-ae68-a5e9d4439b8f.png",
    brand: "Hotty BBQ",
    product: "Hotty Halo",
    metaAdId: "120246534717740719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/fa137139-343f-49a8-805a-d06cae1109d8.png",
    brand: "Leguano",
    product: "go: black",
    metaAdId: "120243539855510633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/5f308f73-fb45-4222-950b-3a556144860d.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121886090719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/b720eec9-239a-4429-80ad-14ae8b1ef011.png",
    brand: "Leguano",
    product: "go: gold",
    metaAdId: "120243267650710633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/67f620d7-f113-4e48-b404-bbf771678199.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Majestic",
    metaAdId: "120248121782710719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/f2622cf5-4e27-4364-b7e7-e352021e71ce.png",
    brand: "Leguano",
    product: "go: mint",
    metaAdId: "120243597197130633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/9639d034-37da-4539-815c-c5311fe99be7.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Medium",
    metaAdId: "120248126265690719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/f3db48e1-75ba-400d-905d-5e0b11425da0.png",
    brand: "Leguano",
    product: "go: nature",
    metaAdId: "120243287797200633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/74ba3265-88f1-4531-a3d7-9e6edc861307.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Single",
    metaAdId: "120248126021820719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/706d1467-2b20-4c42-944a-7e412e2bbf71.png",
    brand: "Leguano",
    product: "jara bordeaux",
    metaAdId: "120249293040660633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/c7586565-d90f-40b0-b029-3e65a180067c.png",
    brand: "Hotty BBQ",
    product: "Hotty Halo",
    metaAdId: "120246534713590719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/c99e4c38-fd76-4ef9-9bb4-300b04e31218.png",
    brand: "Leguano",
    product: "jara leo",
    metaAdId: "120249193239350633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/673db266-17e7-45da-a49d-443ce8193784.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121875340719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/30b63254-4dda-4e42-ac9a-db78041c3e23.png",
    brand: "Leguano",
    product: "jara sand",
    metaAdId: "120247112884060633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/108d1332-9cd9-412b-a2f3-dc37769a5686.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Majestic",
    metaAdId: "120248121780440719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/41c49da9-cbc3-45e7-b6b7-b21069ab734e.png",
    brand: "Leguano",
    product: "jara schwarz",
    metaAdId: "120247112920180633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/17029ad3-9d34-4817-8fd9-cdcefd6716c1.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Medium",
    metaAdId: "120248126263120719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/2133c3c6-90b5-46ce-b7ce-5870c83e7ba3.png",
    brand: "Leguano",
    product: "jaro black",
    metaAdId: "120248733066660633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/2b0ff12b-8175-4096-95dd-29e95e697b26.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Single",
    metaAdId: "120248126019490719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/10a8a1a4-4059-4f50-8ce1-4b73ecf6e571.png",
    brand: "Leguano",
    product: "juno schwarz",
    metaAdId: "120243598723040633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/d92b3304-0d63-4fbd-b010-d055c335506a.png",
    brand: "Hotty BBQ",
    product: "Hotty Halo",
    metaAdId: "120246534704990719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/0a554345-b43a-4dab-9052-f8f64f28529f.png",
    brand: "Leguano",
    product: "kosmo sand",
    metaAdId: "120243598734930633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/edcb6262-a499-4b4e-a017-f8c829cefd5e.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121869890719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/11654964-8953-4b93-83fe-1d9fc2ec3ee8.png",
    brand: "Leguano",
    product: "leguanito go: seablue",
    metaAdId: "120245886453030633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/f4d3be7b-834e-49af-b62a-1ce7c169880a.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Majestic",
    metaAdId: "120248121778200719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/097b01ab-d18d-4e7e-8dc0-52cda1e25124.png",
    brand: "Leguano",
    product: "leguano moreccasin mokka",
    metaAdId: "120246608797510633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/299e89fa-6f8d-44ec-91a5-2edc2dbec8db.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Medium",
    metaAdId: "120248126261210719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/828a9895-739a-4538-9bac-ec0a207340f1.png",
    brand: "Leguano",
    product: "leguano Sandale jara gelb",
    metaAdId: "120249208524620633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/89786f6f-47ec-4439-9348-e48c5144572e.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Single",
    metaAdId: "120248126017180719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/88a89d4f-f4ce-4b87-ae5c-c27e62305391.png",
    brand: "Leguano",
    product: "leguano Sandale jaro",
    metaAdId: "120248731721790633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/642051d2-9f81-47d9-9ba7-8641a905e3cd.png",
    brand: "Hotty BBQ",
    product: "Hotty Halo",
    metaAdId: "120246534696380719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/33f93b6f-8f5f-4eb5-a964-6ca54ddc80a3.png",
    brand: "Leguano",
    product: "leguano Stream",
    metaAdId: "120249202091170633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/096b1afc-daec-469c-ba7c-6798ae8c37fb.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121861960719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/f952c88b-1bbe-4045-aeac-caaef163d82e.png",
    brand: "Leguano",
    product: "leguano style pearl",
    metaAdId: "120249208709040633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/f5428d7e-1720-436c-8738-a34a34c13def.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Majestic",
    metaAdId: "120248121776410719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/57a5f153-5cc5-45f7-9b70-351948bc403e.png",
    brand: "Leguano",
    product: "moreccasin ",
    metaAdId: "120248732881270633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/ba868ff4-286c-4f2a-b92e-544fe7776414.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Medium",
    metaAdId: "120248126259670719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/9fc6db79-a662-473e-ba48-4311e599642a.png",
    brand: "Leguano",
    product: "score black",
    metaAdId: "120243267695510633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/59686fce-984f-4332-97f4-acc63b8968d5.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Single",
    metaAdId: "120248126013980719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/03b3a55a-9fec-4a0d-b75e-1e91ef3825a9.png",
    brand: "Leguano",
    product: "score grey",
    metaAdId: "120248732948860633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/7be41aca-db8e-431d-acf5-ab30f473ed58.png",
    brand: "Hotty BBQ",
    product: "Hotty Halo",
    metaAdId: "120246534689590719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/7f092f9f-1f8e-4699-9e2c-6e10022cdbea.png",
    brand: "Leguano",
    product: "spinwyn  padel",
    metaAdId: "120243539712720633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/119a7c5c-cdeb-4613-8dba-21b2c25af9a2.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121858150719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/c4991bf0-3a33-44b6-9985-488c8175a09d.png",
    brand: "Leguano",
    product: "spinwyn light white",
    metaAdId: "120243445484540633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/c7979dc0-0749-44ca-9575-94a291255e6b.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Majestic",
    metaAdId: "120248121774130719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/f6ae7687-0d41-41cf-8a43-e2bcade88f50.png",
    brand: "Leguano",
    product: "stream",
    metaAdId: "120248809841770633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/542c3c7e-7708-4f57-9bbc-509991beb7d6.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Medium",
    metaAdId: "120248126257280719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/1ab3776b-be53-45ad-8b7b-f21c326b285a.png",
    brand: "Leguano",
    product: "style lavenda",
    metaAdId: "120247201674780633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/f1b0792d-cfef-4daa-867c-d3c45441b927.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Single",
    metaAdId: "120248126011020719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/0104068c-972c-4d8d-b4f7-264c299c4de7.png",
    brand: "Leguano",
    product: "style pearl",
    metaAdId: "120246977242960633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/704849cd-ac42-42f4-b6d7-9cf60b078585.png",
    brand: "Hotty BBQ",
    product: "Hotty Halo",
    metaAdId: "120246534687160719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/23d7b181-b912-41e2-ba3d-b5f3c8fb42e0.png",
    brand: "Leguano",
    product: "aktiv lavaschwarz, schwarze Sohle",
    metaAdId: "120243539831910633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/cb5c7363-46e0-4e96-aec9-f5ee47cecb89.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121851500719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/00310bdf-e943-4ca8-a04e-3066e7e4b77b.png",
    brand: "Leguano",
    product: "attrekktive black",
    metaAdId: "120246607943970633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/402d2536-a013-4c4e-abaf-0737accd9420.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Majestic",
    metaAdId: "120248121770120719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/fc9cebc9-bd3e-4553-85b5-9f8040157ded.png",
    brand: "Leguano",
    product: "beat sand",
    metaAdId: "120243465465060633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/41565665-f7a9-4329-b21b-cc1518142701.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Medium",
    metaAdId: "120248126255550719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/832ef88b-c315-4c68-836c-a2c5f492ccb2.png",
    brand: "Leguano",
    product: "caribeo blue",
    metaAdId: "120245588213380633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/67c53884-44ad-4087-bef2-39f6e68aa1ac.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Single",
    metaAdId: "120248126008530719",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/f173d381-ae7e-414d-b4ca-35dcb903fca7/fb9738b7-14d7-4aec-9629-b20fca399cf0.png",
    brand: "Leguano",
    product: "caribeo rose",
    metaAdId: "120243267737170633",
    status: "published",
  },
  {
    src: "https://jlgpoxhakiyecazjktdv.supabase.co/storage/v1/object/public/brand-assets/dam-assets/4618aa49-35eb-4013-aca4-769328778e1b/919d2ef0-96b9-4c9a-95ff-eea739eda7dd.png",
    brand: "Hotty BBQ",
    product: "Hotty Legacy Double",
    metaAdId: "120248121844260719",
    status: "published",
  },
] as const satisfies readonly PublishedStaticGridAd[];
